import type { SVGProps } from 'react'
import * as React from 'react'

const bookIcon = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18.0418 2H5.14883C3.96697 2 3 2.9 3 4V20C3 21.1 3.96697 22 5.14883 22H18.0418C19.2236 22 20.1906 21.1 20.1906 20V4C20.1906 2.9 19.2236 2 18.0418 2ZM5.14883 4H10.5209V12L7.83486 10.5L5.14883 12V4Z" />
  </svg>
)

export default bookIcon
